import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { QcResponseGrid } from 'src/app/shared/models/grid.model';
import { IS_ACTION, IS_SEARCH } from 'src/app/shared/models/load.models';
import { EnvironmentFacadeService } from 'src/app/shared/services/environment.facade.service';
import { LiteralsFacadeService } from 'src/app/shared/services/literals.facade.service';
import { ClubsLiteralsFacadeService } from 'src/app/shared/services/literals/clubs.literals.facade.service';
import { PaginatorFacadeService } from 'src/app/shared/services/paginator.facade.service';
import { ClubState } from '../models/clubs.models';
import { ClubsSearchFacadeService } from './clubs-search.facade.service';

@Injectable({ providedIn: 'root' })
export class ClubsSearchService {
  constructor(
    private http: HttpClient,
    private environmentFacadeService: EnvironmentFacadeService,
    private paginatorFacadeService: PaginatorFacadeService,
    private literalsFacade: LiteralsFacadeService,
    private clubsSearchFacade: ClubsSearchFacadeService,
    private clubLiteralsFacade: ClubsLiteralsFacadeService,
  ) {}

  search(): Observable<QcResponseGrid> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/club/findByFilter';

    const criteriaList = {
      criteriaList: [
        {
          criteriaType: 'CLUB_DELETE_FLAG_CRITERIA',
          deleteFlag: this.clubsSearchFacade.showInactiveClubs,
        },
        {
          criteriaType: 'CLUB_CODE_CRITERIA',
          clubCode: this.clubsSearchFacade.clubCode,
        },
        {
          criteriaType: 'CLUB_NAME_CRITERIA',
          clubName: this.clubsSearchFacade.clubName,
        },
        {
          criteriaType: 'CLUB_START_DATE_CRITERIA',
          startDate: this.clubsSearchFacade.clubStartDateFormat,
        },
        {
          criteriaType: 'CLUB_END_DATE_CRITERIA',
          endDate: this.clubsSearchFacade.clubEndDateFormat,
        },
      ],
      pagination: {
        page: this.paginatorFacadeService.pageIndex + 1,
        pageSize: this.paginatorFacadeService.itemsNumber,
      },
      sorting: {
        sortingField:
          this.paginatorFacadeService.selectedSortField === this.clubLiteralsFacade.clubName
            ? 'CLUB_NAME'
            : this.paginatorFacadeService.selectedSortField === this.clubLiteralsFacade.clubCode
              ? 'CLUB_CODE'
              : this.paginatorFacadeService.selectedSortField ===
                  this.clubLiteralsFacade.clubStartDate
                ? 'CLUB_START_DATE'
                : 'CLUB_END_DATE',
        sortingOrder:
          this.paginatorFacadeService.selectedOrder ===
          this.literalsFacade.literals.literals['liquid.search.sort.asc']
            ? 'ASC'
            : 'DESC',
      },
    };

    return this.http.post<QcResponseGrid>(url, criteriaList, {
      withCredentials: true,
      context: new HttpContext().set(IS_SEARCH, true),
    });
  }

  edit(row: ClubState): Observable<QcResponseGrid> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/club/findByFilter';

    const criteriaList = {
      criteriaList: [
        {
          criteriaType: 'CLUB_DELETE_FLAG_CRITERIA',
          deleteFlag: row.deleteFlag,
        },
        {
          criteriaType: 'CLUB_CODE_CRITERIA',
          clubCode: row.clubCode,
        },
      ],
      pagination: {
        page: 1,
        pageSize: 1,
      },
      sorting: {
        sortingField: 'CLUB_CODE',
        sortingOrder: 'DESC',
      },
    };

    return this.http.post<QcResponseGrid>(url, criteriaList, {
      withCredentials: true,
      context: new HttpContext().set(IS_ACTION, true),
    });
  }
}
